import { render } from "./QywxChatGroups.vue?vue&type=template&id=0cca49bc"
import script from "./QywxChatGroups.vue?vue&type=script&lang=js"
export * from "./QywxChatGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/h5/ai/chatGroup/QywxChatGroups.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0cca49bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0cca49bc', __exports__)) {
    api.reload('0cca49bc', __exports__)
  }
  
  module.hot.accept("./QywxChatGroups.vue?vue&type=template&id=0cca49bc", () => {
    api.rerender('0cca49bc', render)
  })

}


export default __exports__